var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _extends from "@babel/runtime/helpers/extends";
import { FormControl, MenuItem, Select, styled, Typography } from "@mui/material";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { InputBox, MuiPopup, MuiStack, MuiUseForm } from "..";
import { cancelAppointmentAPI, cancelEstimateAPI, cancelInspectionAPI, cancelJobCardAPI, cancellationReasonListUrl, cancelRevisedEstimateAPI, USER_PROFILE_DATA } from "../../api/url";
import { FeaturedCancelIcon } from "../../assets/images";
import { ECancelDocSystemName, LOCAL_STORAGE_KEYS } from "../../constants";
import { showLoader } from "../../redux/commonSlice";
import { getByIdAPI, updateAPI } from "../../redux/crudSlice";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { getLocalStorageItem } from "../../utils/storageHelper";
import { systemColor } from "../../theme/systemColor";
import useAnalyticsEventTracker from "../../utils/useAnalyticsEventTracker";
import { MuiLoaderButton } from "../atoms/loaderButton";
var initialFValues = {
    cancelReason: ""
};
var MuiSelect = styled(Select)(function (_ref) {
    var theme = _ref.theme;
    return {
        "& fieldset": {
            border: '1px solid #DEE4EB',
            boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)'
        },
        '.MuiOutlinedInput-notchedOutline': {
            borderColor: '#DEE4EB'
        },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: "1px solid #AFD5FF",
            borderRadius: "8px",
            boxShadow: "0px 0px 0px 4px rgba(54, 151, 255, 0.24), 0px 1px 2px 0px rgba(16, 24, 40, 0.05)"
        },
        '&.Mui-disabled': {
            backgroundColor: '#F4F7FA',
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#DEE4EB'
            }
        }
    };
});
export default function CancelDocumentModal(props) {
    var _this = this;
    var _cancelDocumentReason;
    var data = props.data, onCancelPopup = props.onCancelPopup, onCancelClick = props.onCancelClick, title = props.title, subTitle = props.subTitle, SystemName = props.SystemName, cancelPopup = props.cancelPopup;
    var dispatch = useAppDispatch();
    var _a = useAppSelector(function (state) { return state.crud; }), cancelDocumentReasonList = _a.cancelDocumentReasonList, documentDetailsGetById = _a.documentDetailsGetById;
    var _b = useState({}), rejectReason = _b[0], setRejectReason = _b[1];
    var _c = useState(""), rejectRemark = _c[0], setRejectRemark = _c[1];
    var userData = getLocalStorageItem(USER_PROFILE_DATA);
    var profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
    var loader = useAppSelector(function (state) { return state.common.isLoader; });
    var trackButtonClick = useAnalyticsEventTracker('CancelDocumentModal');
    useEffect(function () {
        initialApiCall();
    }, []);
    var initialApiCall = function () { return __awaiter(_this, void 0, void 0, function () {
        var request, result, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    request = {
                        SystemName: SystemName !== null && SystemName !== void 0 ? SystemName : ""
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "cancelDocumentReasonList",
                            url: cancellationReasonListUrl,
                            request: request
                        }))];
                case 1:
                    result = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    console.log("Error-", e_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var validate = function () {
        var fieldValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : values;
    };
    var _d = MuiUseForm(initialFValues, true, validate), values = _d.values, errors = _d.errors, setErrors = _d.setErrors, setValues = _d.setValues, handleInputChange = _d.handleInputChange;
    var onCancelDocument = function () { return __awaiter(_this, void 0, void 0, function () {
        var _userData$data, url, _documentDetailsGetBy, request, _result$payload, _result$payload2, result, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    url = "";
                    if (SystemName === ECancelDocSystemName.Appointment) {
                        url = cancelAppointmentAPI(data === null || data === void 0 ? void 0 : data.AppointmentId);
                    }
                    else if (SystemName === ECancelDocSystemName.Estimate) {
                        if (((_documentDetailsGetBy = documentDetailsGetById.data) === null || _documentDetailsGetBy === void 0 ? void 0 : _documentDetailsGetBy.EstimateType) === "RevisedEstimate") {
                            url = cancelRevisedEstimateAPI(data === null || data === void 0 ? void 0 : data.EstimateId);
                        }
                        else {
                            url = cancelEstimateAPI(data === null || data === void 0 ? void 0 : data.EstimateId);
                        }
                    }
                    else if (SystemName === ECancelDocSystemName.Inspection) {
                        url = cancelInspectionAPI(data === null || data === void 0 ? void 0 : data.InspectionId);
                    }
                    else if (SystemName === ECancelDocSystemName.JobCard) {
                        url = cancelJobCardAPI(data === null || data === void 0 ? void 0 : data.JobCardId);
                    }
                    request = {
                        CancellationReasonId: rejectReason === null || rejectReason === void 0 ? void 0 : rejectReason.id,
                        CancelBy: userData === null || userData === void 0 || (_userData$data = userData.data) === null || _userData$data === void 0 ? void 0 : _userData$data.IdentityId,
                        CancelType: 2,
                        CanceledDateTime: data === null || data === void 0 ? void 0 : data.ScheduledDate,
                        Remark: rejectRemark
                    };
                    if (!(url != '')) return [3 /*break*/, 2];
                    return [4 /*yield*/, dispatch(updateAPI({
                            key: "",
                            url: url,
                            request: request
                        }))];
                case 1:
                    result = _a.sent();
                    if ((result === null || result === void 0 || (_result$payload = result.payload) === null || _result$payload === void 0 ? void 0 : _result$payload.statusCode) == 200 || result !== null && result !== void 0 && (_result$payload2 = result.payload) !== null && _result$payload2 !== void 0 && _result$payload2.success) {
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                        onCancelClick(result);
                    }
                    else {
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                        onCancelPopup(false);
                    }
                    _a.label = 2;
                case 2: return [3 /*break*/, 4];
                case 3:
                    e_2 = _a.sent();
                    console.log("Error-", e_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleInputChangeReason = function (e) {
        setRejectReason(e.target.value);
        setRejectRemark("");
    };
    var handleChangeRejectRemark = function (e) {
        var _e$target;
        setRejectRemark((_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value);
    };
    return /*#__PURE__*/ React.createElement(MuiPopup, {
        variant: "h1",
        openPopup: cancelPopup,
        closeIcon: true,
        backdropEnable: true,
        onClose: function () {
            onCancelPopup(false);
        },
        padding: "15px 0px 0px 15px",
        headerIcon: FeaturedCancelIcon,
        showLoaderOnPopup: true
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        id: 'cancel-popup',
        flexDirection: "column"
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: title,
        fontSize: "xl",
        fontWeight: "strong",
        variant: "caption"
    }, title), /*#__PURE__*/ React.createElement(Typography, {
        id: subTitle,
        fontSize: "base",
        fontWeight: "normal",
        variant: "h4",
        color: "secondary.600",
        marginTop: 1
    }, subTitle), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        spacing: 1,
        marginTop: "16px"
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "reason",
        fontWeight: "medium",
        fontSize: "base",
        paddingY: 1
    }, t("Reason")), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(FormControl, _extends({
        fullWidth: true,
        style: {
            margin: 0
        }
    }, (errors === null || errors === void 0 ? void 0 : errors.cancelReason) && {
        error: true
    }), /*#__PURE__*/ React.createElement(MuiSelect, {
        id: "mui-component-select-cancelReason",
        sx: {
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                border: "1px solid #AFD5FF",
                borderRadius: "8px",
                boxShadow: "0px 0px 0px 4px rgba(54, 151, 255, 0.24), 0px 1px 2px 0px rgba(16, 24, 40, 0.05)"
            },
            color: !(rejectReason !== null && rejectReason !== void 0 && rejectReason.Name) ? '#999' : '#1B1D21',
            margin: 0,
            alignItems: 'center'
            //height: '40px'
        },
        size: "small",
        fullWidth: true,
        defaultValue: "select",
        name: "cancelReason",
        value: rejectReason === null || rejectReason === void 0 ? void 0 : rejectReason.Name,
        onChange: function (item) { return handleInputChangeReason(item); },
        placeholder: "Cancellation reason",
        MenuProps: {
            PaperProps: {
                sx: {
                    maxHeight: '250px',
                    marginLeft: '3px',
                    marginRight: '40px',
                    marginTop: '5px'
                }
            }
        }
        //displayEmpty
    }, /*#__PURE__*/ React.createElement(MenuItem, {
        id: "select-reason",
        disabled: true,
        value: "select"
    }, t("Select reason")), cancelDocumentReasonList && (cancelDocumentReasonList === null || cancelDocumentReasonList === void 0 || (_cancelDocumentReason = cancelDocumentReasonList.data) === null || _cancelDocumentReason === void 0 ? void 0 : _cancelDocumentReason.map(function (item, index) { /*#__PURE__*/ return React.createElement(MenuItem, {
        key: index,
        value: item,
        id: "cancel-reason".concat(index),
        style: {
            textWrap: "pretty",
            overflowX: "scroll",
            textTransform: 'capitalize'
        }
    }, item.Name); })))))), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        spacing: 1,
        marginTop: "16px"
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "remarks",
        fontWeight: "medium",
        fontSize: "base",
        paddingY: 1
    }, t("Remarks")), /*#__PURE__*/ React.createElement(InputBox, {
        id: 'enter-remarks',
        multiline: true,
        placeholder: t('ENTER_REMARKS_PLACEHOLDER'),
        onChange: function (event) { return handleChangeRejectRemark(event); },
        fullWidth: true,
        rows: 4
        //size="small"
        ,
        value: rejectRemark,
        style: {
            fontSize: 'base',
            fontWeight: 'normal',
            color: rejectRemark ? '#999' : 'secondary.900'
        }
    })), /*#__PURE__*/ React.createElement(MuiLoaderButton, {
        loading: loader.isLoaderOpen,
        id: "confirmButton",
        name: t("Confirm"),
        size: "medium",
        style: {
            backgroundColor: systemColor.primary,
            borderColor: systemColor.primary,
            color: "#FFFFFF",
            fontSize: "lg",
            fontWeight: "medium",
            marginTop: "16px",
            opacity: !(rejectReason !== null && rejectReason !== void 0 && rejectReason.id) || rejectReason.Name == 'Others' && !rejectRemark ? 0.5 : 1
        },
        disabled: !(rejectReason !== null && rejectReason !== void 0 && rejectReason.id) || rejectReason.Name == 'Others' && !rejectRemark,
        onClick: function () {
            onCancelDocument();
            trackButtonClick("ButtonClickEvent", "".concat(SystemName) + "_Cancel_Confirm_Click", undefined);
        }
    }), /*#__PURE__*/ React.createElement(MuiLoaderButton, {
        loading: loader.isLoaderOpen,
        id: "cancelButton",
        name: t("Cancel"),
        size: "medium",
        style: {
            borderColor: "secondary.200",
            color: "secondary.600",
            fontSize: "lg",
            fontWeight: "medium",
            marginTop: "16px"
        },
        onClick: function () {
            onCancelPopup(false);
            trackButtonClick("ButtonClickEvent", "".concat(SystemName) + "_Cancel_Cancel_Click", undefined);
        }
    })));
}
